export default "__VITE_ASSET__5e38afe9__"